import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CardMedia } from '@mui/material';
import { makeStyles } from '@mui/styles';

import QuantumLogoIcon from '../icons/Quantum2.0Logo';
import loginSplash from '../../assets/png/loginSplash.png';
import palette from '../styles/palette';
import Button from '../Button';
import { Text } from '../Base';
import {
  RELOAD_PAGE,
  SOMETHING_WENT_WRONG,
  THERE_WAS_AN_ERROR,
} from '../../constants/strings';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: 'flex',
  },
  gradient: {
    display: 'flex',
    flex: 1,
    zIndex: 2,
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.8) 100%)',
  },
  splash: {
    zIndex: 1,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  headerText: {
    fontWeight: 500,
    fontSize: typography.pxToRem(24),
    lineHeight: typography.pxToRem(20),
    letterSpacing: '-0.02em',
  },
  text: {
    fontSize: typography.pxToRem(18),
    lineHeight: typography.pxToRem(20),
    letterSpacing: '-0.02em',
    paddingTop: typography.pxToRem(18),
    paddingBottom: typography.pxToRem(32),
  },
  icon: {
    position: 'absolute',
    top: 70,
  },
}));

const SomethingWentWrong = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const onReload = useCallback(() => navigate(0), [navigate]);

  return (
    <Box width="100%" className={styles.container}>
      <Box className={styles.gradient}>
        <Box className={styles.icon}>
          <QuantumLogoIcon />
        </Box>
        <Box className={styles.textContainer}>
          <Text className={styles.headerText}>{THERE_WAS_AN_ERROR}</Text>
          <Text className={styles.text}>{SOMETHING_WENT_WRONG}</Text>
          <Button
            variant="contained"
            disableElevation
            sx={{ backgroundColor: palette.btn.blueFill }}
            bgColor={palette.btn.blueFill}
            data-testid="reload-page"
            onClick={onReload}
          >
            {RELOAD_PAGE}
          </Button>
        </Box>
      </Box>
      <CardMedia className={styles.splash} image={loginSplash} />
    </Box>
  );
};

export default SomethingWentWrong;
